// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

export const usageCreateRecord = /* GraphQL */ `
	mutation UsageCreateRecord($input: CreateUsageRecordInput!) {
		usageCreateRecord(input: $input) {
			id
			userId
			userName
			jobId
			jobType
			timestamp
			billingPeriod
			metricType
			metricValue
			sourceLanguage
			targetLanguageCount
			contentType
			costRateApplied
			estimatedCost
			incomplete
			archived
		}
	}
`;

export const costRateUpdate = /* GraphQL */ `
	mutation CostRateUpdate($input: UpdateCostRateInput!) {
		costRateUpdate(input: $input) {
			id
			characterCostRate
			effectiveTimestamp
			updatedBy
		}
	}
`;

export const reportScheduleUpdate = /* GraphQL */ `
	mutation ReportScheduleUpdate($input: UpdateReportScheduleInput!) {
		reportScheduleUpdate(input: $input) {
			id
			schedule
			format
			recipients
			updatedBy
			updatedAt
		}
	}
`;
